/**
 * @file   src\components\InputIcon.tsx
 * @brief  Html input component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import React from 'react';
import "../components/CWInput.scss";
import SearchIcon from '../assets/images/icons/search';
import CloseIcon from '../assets/images/icons/close';
import { InputProperty } from '../interfaces/generalInterface';

interface InputIconInterface extends InputProperty {
  onChange?: (str: React.ChangeEvent<HTMLInputElement>) => void;
}

const CWSearchinput = ({ onChange, onClose, id, name, type, value, placeholder, disabled, maxLength, icon, errorMessage }: InputIconInterface) => {
  const onIconChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(e);
  };

  // To clear input
  const handleCloseClick = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    if (onClose) onClose(e);
  };


  return (
    <div className="form-group cw-input">
      <div className="cust-ic-group position-relative">
        <input
          className={errorMessage && errorMessage !== '' ? 'form-control error' : value && value !== '' ? 'form-control active' : 'form-control'}
          id={id}
          name={name}
          type={type}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          onChange={(event) => onIconChange(event)}
        />
        <span className="icon-wrap"><SearchIcon /></span>
        {value ? <span className="icon-wrap close-icon" onClick={handleCloseClick}><CloseIcon /></span> : null}
        {errorMessage && errorMessage !== '' && <span className="error">{errorMessage}</span>}
      </div>
    </div>
  );
};

export default CWSearchinput;
